/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Status_RunningInputs */

const en_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

const ar_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يعمل الآن`)
};

const bn_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চলমান`)
};

const de_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufen`)
};

const es_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corriendo`)
};

const fr_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours d'exécution`)
};

const pt_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em execução`)
};

const zh_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运行`)
};

const tr_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışıyor`)
};

const ru_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бег`)
};

const pl_service_status_running = /** @type {(inputs: Service_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bieganie`)
};

/**
* | output |
* | --- |
* | "Running" |
*
* @param {Service_Status_RunningInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_status_running = /** @type {((inputs?: Service_Status_RunningInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Status_RunningInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_service_status_running(inputs)
	if (locale === "bn") return bn_service_status_running(inputs)
	if (locale === "de") return de_service_status_running(inputs)
	if (locale === "es") return es_service_status_running(inputs)
	if (locale === "fr") return fr_service_status_running(inputs)
	if (locale === "pt") return pt_service_status_running(inputs)
	if (locale === "zh") return zh_service_status_running(inputs)
	if (locale === "tr") return tr_service_status_running(inputs)
	if (locale === "ru") return ru_service_status_running(inputs)
	if (locale === "pl") return pl_service_status_running(inputs)
	return en_service_status_running(inputs)
});